(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sfr-file', {
            parent: 'import',
            url: '/sfr-file?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.sfrFile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sfr-file/sfr-files.html',
                    controller: 'SfrFileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sfrFile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sfr-file-detail', {
            parent: 'sfr-file',
            url: '/sfr-file/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.sfrFile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sfr-file/sfr-file-detail.html',
                    controller: 'SfrFileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sfrFile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SfrFile', function($stateParams, SfrFile) {
                    return SfrFile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sfr-file',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sfr-file-detail.edit', {
            parent: 'sfr-file-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sfr-file/sfr-file-dialog.html',
                    controller: 'SfrFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SfrFile', function(SfrFile) {
                            return SfrFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sfr-file.new', {
            parent: 'sfr-file',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sfr-file/sfr-file-dialog.html',
                    controller: 'SfrFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: new Date(),
                                fileName: null,
                                file: null,
                                fileContentType: null,
                                nbInterventions: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sfr-file', null, { reload: 'sfr-file' });
                }, function() {
                    $state.go('sfr-file');
                });
            }]
        })
        .state('sfr-file.edit', {
            parent: 'sfr-file',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sfr-file/sfr-file-dialog.html',
                    controller: 'SfrFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SfrFile', function(SfrFile) {
                            return SfrFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sfr-file', null, { reload: 'sfr-file' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sfr-file.delete', {
            parent: 'sfr-file',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sfr-file/sfr-file-delete-dialog.html',
                    controller: 'SfrFileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SfrFile', function(SfrFile) {
                            return SfrFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sfr-file', null, { reload: 'sfr-file' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
